<template>
  <div>
    <el-select :value="status" value-key="key" :size="size" :placeholder="$t('card.certification')" @input="change($event)" :clearable="true">
      <el-option label="未实名" value="0" />
      <el-option label="已实名" value="1" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: null
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.status = val
      this.$emit('input', this.status)
    }
  },
  mounted () {
    this.status = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.status = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CertificationSelect.vue